import { useVuex } from "@vueblocks/vue-use-vuex";
import { useStore } from "vuex";

/**
 * Unfortunately, we need to wrap @vueblocks/vue-use-vuex
 * in our helpers - to make them work well
 *
 * this abstraction is required since we should always useStore() from vuex to make that work [!]
 * */

// keys / namespace adapter:
const settleNameSpace = (namespace, keys) => ({
    namespace: typeof namespace !== "string" ? undefined : namespace,
    keys: typeof namespace !== "string" ? namespace : keys,
});

export function useState(namespace, keys = []) {
    const ns = settleNameSpace(namespace, keys);
    return useVuex(ns.namespace, useStore()).useState(ns.keys);
}

export function useActions(namespace, keys = []) {
    const ns = settleNameSpace(namespace, keys);
    return useVuex(ns.namespace, useStore()).useActions(ns.keys);
}

export function useMutations(namespace, keys) {
    const ns = settleNameSpace(namespace, keys);
    return useVuex(ns.namespace, useStore()).useMutations(ns.keys);
}

export function useGetters(namespace, keys) {
    const ns = settleNameSpace(namespace, keys);
    return useVuex(ns.namespace, useStore()).useGetters(ns.keys);
}
